import Flux from 'lib/flux';
import ModalConstants from 'constants/modal';

const ModalStore = Flux.createStore({
  name: 'modal',

  getInitialState() {
    return {
      visible: false,
      header: null,
      content: null,
      triggeringElement: null,
      actions: null,
      className: '',
      settings: {},
      showIcon: false,
    };
  },

  actions: [
    [
      ModalConstants.SHOW,
      function (contents) {
        this.state = this.state.set('header', contents.header);
        this.state = this.state.set('content', contents.content);
        this.state = this.state.set(
          'triggeringElement',
          contents.triggeringElement
        );
        this.state = this.state.set('actions', contents.actions);
        this.state = this.state.set('className', contents.className || '');
        this.state = this.state.set('settings', contents.settings || {});
        this.state = this.state.set('visible', true);
        this.state = this.state.set(
          'showIcon',
          contents.showIcon !== undefined ? contents.showIcon : true
        );
      },
    ],

    [
      ModalConstants.HIDE,
      function () {
        this.state = this.state.set('visible', false);
      },
    ],
  ],
});

export default ModalStore;
